import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';
import { usePricing } from '../contexts/PricingContext';
import { ContactFormPopup } from './ContactFormPopup';
export function HeroVariant21() {
  const {
    language
  } = useLanguage();
  const {
    price
  } = usePricing();
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const content = {
    ru: {
      badge: 'Новый стандарт веб-разработки',
      title1: 'Ваш новый сайт.',
      title2: '0$ за разработку.',
      sub: `Мы берем на себя дизайн и код. Вы оплачиваете только поддержку и хостинг — ${price}/мес. Никаких скрытых платежей.`,
      cta: 'Получить бесплатный макет',
      features: ['Бесплатный дизайн', 'Адаптивная верстка', 'Безлимитные правки']
    },
    ua: {
      badge: 'Новий стандарт веб-розробки',
      title1: 'Ваш новий сайт.',
      title2: '0$ за розробку.',
      sub: `Ми беремо на себе дизайн та код. Ви оплачуєте лише підтримку та хостинг — ${price}/міс. Жодних прихованих платежів.`,
      cta: 'Отримати безкоштовний макет',
      features: ['Безкоштовний дизайн', 'Адаптивна верстка', 'Безлімітні правки']
    },
    en: {
      badge: 'The new standard of web development',
      title1: 'Your new website.',
      title2: '$0 for development.',
      sub: `We handle the design and code. You only pay for support and hosting — ${price}/mo. No hidden fees.`,
      cta: 'Get a free mockup',
      features: ['Free design', 'Responsive layout', 'Unlimited edits']
    }
  }[language] || content.ru;
  return <>
      <section className="relative min-h-screen w-full overflow-hidden pt-32 pb-20 flex items-center" style={{
      backgroundColor: 'var(--bg-primary)'
    }} data-id="element-468">
        <div className="relative z-10 mx-auto flex w-full max-w-7xl flex-col lg:flex-row items-center justify-between gap-12 px-4" data-id="element-469">
          {/* Left Column - Premium Clean Typography */}
          <div className="w-full lg:w-1/2 text-left flex flex-col items-start" data-id="element-470">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} className="mb-4 text-sm font-bold tracking-widest uppercase" style={{
            color: 'var(--accent)'
          }} data-id="element-471">
              {content.badge}
            </motion.div>

            <motion.h1 initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.1
          }} className="mb-6 text-5xl lg:text-6xl xl:text-[4.5rem] font-black leading-[1.1] tracking-tight text-gray-900" data-id="element-472">
              <span className="block text-gray-900" data-id="element-473">{content.title1}</span>
              <span className="block text-transparent bg-clip-text bg-gradient-to-r from-blue-600 to-blue-400" data-id="element-474">
                {content.title2}
              </span>
            </motion.h1>

            <motion.p initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.2
          }} className="text-lg md:text-xl mb-8 text-gray-600 font-medium max-w-lg leading-relaxed" data-id="element-475">
              {content.sub}
            </motion.p>

            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            delay: 0.3
          }} className="flex flex-col sm:flex-row gap-4 w-full sm:w-auto mb-10" data-id="element-476">
              <button onClick={() => setIsPopupOpen(true)} className="group flex items-center justify-center gap-2 rounded-2xl px-8 py-4 font-bold text-lg transition-all hover:scale-105 shadow-xl shadow-blue-500/20" style={{
              backgroundColor: 'var(--accent)',
              color: '#FFFFFF'
            }} data-id="element-477">
                {content.cta}
                <ArrowRightIcon className="w-5 h-5 transition-transform group-hover:translate-x-1" data-id="element-478" />
              </button>
            </motion.div>

            <motion.div initial={{
            opacity: 0
          }} animate={{
            opacity: 1
          }} transition={{
            delay: 0.5
          }} className="flex flex-wrap gap-6 text-sm font-semibold text-gray-500" data-id="element-479">
              {content.features.map((feat, i) => <div key={i} className="flex items-center gap-2" data-id="element-480">
                  <div className="w-1.5 h-1.5 rounded-full bg-blue-500" data-id="element-481" />
                  {feat}
                </div>)}
            </motion.div>
          </div>

          {/* Right Column - Clean Video */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8
        }} className="w-full lg:w-1/2 relative mt-12 lg:mt-0" data-id="element-482">
            <div className="relative w-full max-w-2xl mx-auto rounded-3xl overflow-hidden shadow-2xl border border-gray-100" data-id="element-483">
              <video src="https://cdn.magicpatterns.com/uploads/vrXe21wkVqS62d5BzpZ9eJ/original-2de319f4767c5a0d4acf4f107b938504.mp4" autoPlay loop muted playsInline className="w-full h-auto" data-id="element-484" />
            </div>
          </motion.div>
        </div>
      </section>
      <ContactFormPopup isOpen={isPopupOpen} onClose={() => setIsPopupOpen(false)} data-id="element-485" />
    </>;
}